// #region Dependencias
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { sharedButtonStyle } from './Button'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledButtonLink = styled(Link).attrs((props) => ({
  style: {
    backgroundColor:
      props.color === 'primary'
        ? colors.primary
        : props.color === 'secondary'
          ? colors.secondary
          : props.color === 'tertiary'
            ? colors.tertiary
            : props.color === 'dark'
              ? colors.text
              : props.color,
    borderRadius: `${props.borderradius}rem`
  }
}))`
  ${sharedButtonStyle}
  padding: ${({ size = 'normal' }) => (size === 'large' ? '4rem' : '')};
  white-space: nowrap;
  place-self: center;
`

// #endregion

/**
 * Componente que renderiza un botón de navegación con react-router-dom
 *
 * @class
 * @example
 * <ButtonLink  color="primary" disabled={true} size="normal" text="Guardar" to="/home" />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.color="primary"] - Color de fondo del botón.
 * @param {boolean} [props.disabled=false] - Valor que indica si el botón está desactivado.
 * @param {Object} [props.size="normal"] - Tamaño del botón.
 * @param {string} props.text - Texto del botón.
 * @param {string} props.to - Ruta a la que será redirigido el usuario al hacer click en el botón.
 */
const ButtonLink = ({ disabled = false, text, to, ...props }) => {
  return (
    <StyledButtonLink disabled={disabled} to={to} {...props}>
      {text}
    </StyledButtonLink>
  )
}

export default ButtonLink
